import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { AzureBlobStorageService } from '../../../services/azure-blob-storage.service';
import { switchMap, withLatestFrom, map, catchError, combineLatest, filter } from 'rxjs/operators';
import { of, Observable } from 'rxjs';
import { Store } from '@ngrx/store';
import * as fromStore from '../../../store';
import * as featureActions from '../../index';
import { AzureBlobStorageActionTypes, AzureBlobStorageActions } from '../actions/azure-blob-storage.actions';
import { AzureBlobStorageParam, AzureBlobStorage } from '../azure-blob-storage.model';


@Injectable()
export class AzureBlobStorageEffects {
  private actions$ = inject(Actions);
  private store$ = inject(Store<fromStore.State>);
  private azureBlobStorageService = inject(AzureBlobStorageService);

  constructor() {}

  DownloadAzureBlobStorages$ = createEffect(() => this.actions$.pipe(
    ofType(AzureBlobStorageActionTypes.GetDownLoadAzureBlobStorages),
    withLatestFrom(this.store$.select(fromStore.GetAzureBlobStoragesSASToken)),
    switchMap(([action, token]: [any, any]) => {
      const param: AzureBlobStorageParam = {
        name: action.payload.name,
        path: action.payload.path,
        timestamp: action.payload.timestamp,
        container: action.payload.container,
      };
      param.token = (token) ? token.entities : null;
      const result = this.azureBlobStorageService.ReadAzureBlobStorageFile(param);
      return of(new featureActions.DownloadAzureBlobStoragesSuccess({ azureBlobStorages: result, action: 'download' }));
    })
  ));
  UploadAzureBlobStorages$ = createEffect(() => this.actions$.pipe(
    ofType(AzureBlobStorageActionTypes.GetUploadAzureBlobStorages),
    withLatestFrom(this.store$.select(fromStore.GetAzureBlobStoragesSASToken)),
    filter(([action, token]) => token.isLoaded && !token.isLoading),
    switchMap(([action, token]: [any, any]) => {
      const param: AzureBlobStorageParam = {
        name: action.payload.name,
        path: action.payload.path,
        token: token.entities,
        file: action.payload.file,
        timestamp: action.payload.timestamp,
        container: action.payload.container,
      };
      const result = this.azureBlobStorageService.UploadAzureBlobStorageFile(param, () => {});
      return of(new featureActions.UploadAzureBlobStoragesSuccess({ azureBlobStorages: result, action: 'upload' }));
    })
  ));
  GetAzureBlobStoragesSASToken$ = createEffect(() => this.actions$.pipe(
    ofType(AzureBlobStorageActionTypes.GetAzureBlobStoragesSASToken),
    switchMap((action) => {
      return this.azureBlobStorageService.generateSharedAccessSignature().pipe(
        map((res: any) => {
          return new featureActions.AddAzureBlobStoragesSASToken(res);
        })
      );
    })
  ));

}
